import React , { Component } from 'react';
import PropTypes from 'prop-types';

import {Link} from 'react-router';

export default class LockableLink extends Component {

  render() {

    return (
      <div style={{border:'none'}}>
        {this.props.isLocked?<a style={{cursor:'wait'}}>{this.props.children}</a>:<Link to={this.props.to} onClick={this.props.onCLick}>{this.props.children}</Link>}
      </div>
    )
  }

}


LockableLink.PropTypes = {
    isLocked: PropTypes.bool.isRequired,
    to: PropTypes.object.isRequired,
    onClick: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/LockableLink.js